export default __webpack_public_path__ + "cba85bb39806050e6d072a5bf3e6308b.jpg";